import {Component, OnInit} from '@angular/core';
import {SdaiService} from '../../create-application/sdai-form/sdai.service';
import {LoginService} from '../../shared/services/login.service';
import {SelectItem} from 'primeng/primeng';
import * as _ from 'lodash';

import {AppHistoryDetails} from '../../shared/data-objects/app-history-details';

@Component({
  selector: 'app-allocate-applications',
  templateUrl: './allocate-applications.component.html',
  styleUrls: ['./allocate-applications.component.css']
})
export class AllocateApplicationsComponent implements OnInit {

  applications: AppHistoryDetails[];
  noApplicationsFound: boolean;
  applicationTypes: SelectItem[];
  applicationStatuses: SelectItem[];
  teamMembers: SelectItem[];
  isRequesting: boolean;

  constructor(private loginService: LoginService, private sdaiService: SdaiService) {
    this.applications = [];
    this.applicationTypes = [];
    this.applicationStatuses = [];
    this.applicationStatuses = [];
    this.teamMembers = [];
  }

  ngOnInit() {
    this.applicationTypes = [];
    this.applicationStatuses = [];

    // Get officers
    this.teamMembers = [];
    this.teamMembers.push({label: 'Please select...', value: ''});
    this.sdaiService.getOfficers(
      this.loginService.getToken()).subscribe((officers: string[]) => {
      if (officers != null && officers.length > 0) {
        officers.map((officer) => {
          this.teamMembers.push({label: officer, value: officer});
        });
      }
    }, err => {
      // Log errors if any
      console.log(err);
    });
    this.refresh();

    this.loginService.refreshToken();
  }

  public refresh() {
// get unallocated applications
    this.applications = [];
    this.applicationTypes = [];
    this.isRequesting = true;
    this.sdaiService.getUnallocated(
      this.loginService.getToken()).subscribe((applications) => {
      this.isRequesting = false;
      if (applications == null || applications.length === 0) {
        this.noApplicationsFound = true;
      } else {
        this.noApplicationsFound = false;
        for (let i = 0; i < applications.length; i++) {
          applications[i]['allocateTo'] = '';
          applications[i]['isRequesting'] = false;
          applications[i]['updateErrorMessage'] = '';
        }

        this.applications = applications;

        this.applicationTypes.push({label: 'All Types', value: null});
        _.uniq(_.map(applications, 'applicationType')).map((t: string) => {
          this.applicationTypes.push({label: t, value: t});
        });
        this.applicationStatuses.push({label: 'All Statuses', value: null});
        _.uniq(_.map(applications, 'status')).map((t: string) => {
          this.applicationStatuses.push({label: t, value: t});
        });
      }
    }, err => {
      this.isRequesting = false;
      // Log errors if any
      this.noApplicationsFound = true;
      console.log(err);
    });
  }

  changed(application: AppHistoryDetails) {
    application['isRequesting'] = true;
    application['updateErrorMessage'] = '';

    this.sdaiService.allocateApplication(application.damsApplicationID, application['allocateTo'],
      this.loginService.getToken()).subscribe((ok: boolean) => {
        application['isRequesting'] = false;
      },
      err => {
        // Log errors if any
        application['isRequesting'] = false;
        if (err) {
          console.log(err);
          application['updateErrorMessage'] = 'Server Error';
        } else {
          console.log('Unknown error');
          application['updateErrorMessage'] = 'Server Error';
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/manage-applications/allocate-applications/allocate-applications.component.ts